/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Template_EditorialInputs */

const cs_public_site_template_editorial = /** @type {(inputs: Public_Site_Template_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redakční`)
};

const en_public_site_template_editorial = /** @type {(inputs: Public_Site_Template_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

/**
* | output |
* | --- |
* | "Editorial" |
*
* @param {Public_Site_Template_EditorialInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_template_editorial = /** @type {((inputs?: Public_Site_Template_EditorialInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Template_EditorialInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_template_editorial(inputs)
	return cs_public_site_template_editorial(inputs)
});